import { defineStore } from "pinia";
import { computed } from "vue";
import { createStatusApi } from "#ce/apps/SpInsuranceApp/api/status";
import { Status } from "#ce/apps/SpInsuranceApp/models/status";
import { useLatestRequest } from "#ce/composables/useLatestRequest";

export const useSharedStatusStore = (props) => {
  const api = props.statusApi ?? createStatusApi(props.url);

  const init = defineStore("status", () => {
    // Every insurance app on the page loads into this store, so only the
    // latest request's outcome is kept; `load` rejects only when that request fails.
    const request = useLatestRequest((insurancePlanId) => api.status(insurancePlanId), { throwError: true });
    const status = computed(() => request.state.value ?? null);
    const { error, loading } = request;

    async function load(insurancePlanId) {
      await request.execute(insurancePlanId);
    }

    return {
      // state
      status,
      error,
      loading,

      // actions
      load,
    };
  });

  return init();
};

export const useStatusStore = (attributes) => ({
  // state
  status: Status.from(attributes),
});
